var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.$t('all_notification'),"icon":"bell"}})],1)]),_vm._v(" "),_c('app-table',{attrs:{"id":_vm.tableId,"options":_vm.options},on:{"action":_vm.triggerActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }